import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box, Button, IconButton, Switch, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useOutletContext } from "react-router-dom";
import AmountLargeBox from "../../../components/shared/AmountLargeBox";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import BalootKeyboard from "../../../components/shared/BalootKeyboard";
import BottomFullWidthButtonContainer from "../../../components/shared/BottomFullWidthButtonContainer";
import ErrorMessageText from "../../../components/shared/ErrorMessageText";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import { getDirectDebitPeriodTitle, toToman } from "../../../utils/Utils";

function DirectDebitSetAmountPage() {
  const { editableSubscription, setEditableSubscription } = useOutletContext();
  const [editedAmount, setEditedAmount] = useState(
    Math.round(editableSubscription.amount / 10)
  );
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { config } = useSelector((state) => state.config);

  const submitHandler = () => {
    if (editedAmount * 10 < config.recurringMinAmount) {
      setErrorMessage(
        `مقدار وارد شده از حداقل مبلغ (${toToman(
          config.recurringMinAmount
        )} تومان) کمتر است.`
      );
    } else {
      setEditableSubscription((prev) => {
        return { ...prev, amount: editedAmount * 10 };
      });
      navigate(-1);
    }
  };

  useEffect(() => {
    if (!!errorMessage) {
      setErrorMessage("");
    }
  }, [editedAmount]);

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            پس‌انداز خودکار
          </Typography>
        }
      />
      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        <AmountLargeBox amount={editedAmount * 10} error={!!errorMessage} />
        <Box minHeight={60}>
          <>
            <ErrorMessageText sx={{ mt: 1 }} errorMessage={errorMessage} />
            <Typography
              align="center"
              mt={"8px"}
              variant="subtitle1"
              color="primary.main"
            >
              {`${getDirectDebitPeriodTitle(editableSubscription)}`}
            </Typography>
          </>
        </Box>
        <BalootKeyboard sx={{ mt: "32px" }} setAmount={setEditedAmount} />
        <BottomFullWidthButtonContainer>
          <Button
            onClick={submitHandler}
            sx={{
              color: "common.white",
              typography: "h3",
            }}
            variant="contained"
            fullWidth
          >
            ذخیره مبلغ
          </Button>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
    </>
  );
}

export default DirectDebitSetAmountPage;
